var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgActivities(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fe:activity"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feActivity0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "feActivity1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "feActivity2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.16675 15.833C9.16675 16.054 9.07895 16.266 8.92267 16.4223C8.76639 16.5785 8.55443 16.6663 8.33342 16.6663C8.1124 16.6663 7.90044 16.5785 7.74416 16.4223C7.58788 16.266 7.50008 16.054 7.50008 15.833V6.66634C7.50008 6.44533 7.58788 6.23337 7.74416 6.07709C7.90044 5.92081 8.1124 5.83301 8.33342 5.83301C8.55443 5.83301 8.76639 5.92081 8.92267 6.07709C9.07895 6.23337 9.16675 6.44533 9.16675 6.66634V15.833ZM5.83341 15.833C5.83341 16.054 5.74562 16.266 5.58934 16.4223C5.43306 16.5785 5.2211 16.6663 5.00008 16.6663C4.77907 16.6663 4.56711 16.5785 4.41083 16.4223C4.25455 16.266 4.16675 16.054 4.16675 15.833V9.99967C4.16675 9.77866 4.25455 9.5667 4.41083 9.41042C4.56711 9.25414 4.77907 9.16634 5.00008 9.16634C5.2211 9.16634 5.43306 9.25414 5.58934 9.41042C5.74562 9.5667 5.83341 9.77866 5.83341 9.99967V15.833ZM10.8334 15.833V8.33301C10.8334 8.11199 10.9212 7.90003 11.0775 7.74375C11.2338 7.58747 11.4457 7.49967 11.6667 7.49967C11.8878 7.49967 12.0997 7.58747 12.256 7.74375C12.4123 7.90003 12.5001 8.11199 12.5001 8.33301V15.833C12.5001 16.054 12.4123 16.266 12.256 16.4223C12.0997 16.5785 11.8878 16.6663 11.6667 16.6663C11.4457 16.6663 11.2338 16.5785 11.0775 16.4223C10.9212 16.266 10.8334 16.054 10.8334 15.833ZM14.1667 4.16634C14.1667 3.94533 14.2545 3.73337 14.4108 3.57709C14.5671 3.42081 14.7791 3.33301 15.0001 3.33301C15.2211 3.33301 15.4331 3.42081 15.5893 3.57709C15.7456 3.73337 15.8334 3.94533 15.8334 4.16634V15.833C15.8334 16.054 15.7456 16.266 15.5893 16.4223C15.4331 16.5785 15.2211 16.6663 15.0001 16.6663C14.7791 16.6663 14.5671 16.5785 14.4108 16.4223C14.2545 16.266 14.1667 16.054 14.1667 15.833V4.16634Z",
    fill: "white",
    fillOpacity: 0.9
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivities);
export default __webpack_public_path__ + "static/media/activities.c79a5e91030cb8d815b325279864d6d9.svg";
export { ForwardRef as ReactComponent };